"use client";
import BackButton from "@/components/BackButton/BackButton";
import Coupon from "@/components/Coupon/Coupon";
import { useDictionary } from "@/components/DictProvider/DictProvider";
import React from "react";

const Coupons = ({ data }: { data: any }) => {
  const dict = useDictionary();
  return (
    <div className="mx-1.5 md:mx-7 xl:mx-20 my-3 md:my-6  rounded-lg">
      <p className=" text-2xl font-semibold px-6 xl:px-10 pt-3 ">
        <BackButton text={dict?.myCoupon?.myCoupons} />
      </p>
      <div className=" grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3  justify-items-center py-4 xl:pb-10">
        {data.map((item: any, index: number) => (
          <React.Fragment key={index}>
            <Coupon />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Coupons;
